"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = void 0;
/**
 * Pobiera element znajdujący się w obiekcie pod daną ścieżką
 *
 * @export
 * @param {object} obj
 * @param {(string | string[])} objectPath
 * @returns {*}
 */
function getPath(obj, objectPath) {
    if (!Array.isArray(objectPath)) {
        objectPath = objectPath.split('.');
    }
    return objectPath.reduce((current, key) => {
        if (!current) {
            return current;
        }
        else if (current instanceof Promise) {
            return current.then((value) => value[key]);
        }
        return current[key];
    }, obj);
}
exports.getPath = getPath;
//# sourceMappingURL=getPath.js.map